import { render, staticRenderFns } from "./PreviewCourseEnrollComponent.vue?vue&type=template&id=5c84850c&"
import script from "./PreviewCourseEnrollComponent.vue?vue&type=script&lang=js&"
export * from "./PreviewCourseEnrollComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports